'use strict';

//@see https://www.html5rocks.com/en/tutorials/eventsource/basics/
//and https://html.spec.whatwg.org/multipage/server-sent-events.html#server-sent-events
//and https://hpbn.co/server-sent-events-sse/

//note device check is in bootstrap.js

//*****************************************
// The exports can be generate with regex replace
// [\r\n]var
// \r\nexport var

//IMPORTANT: exported variables are always Read-Only!!!!!

//*****************************************

// import * as util from './util.js'

import {ebus} from '../vendor/ebus';

var eSource = null;
var eStreamOpen;
var retrySsePath, retryOpenCallback, retryClosedCallback, retryEdispatcher, retryUid = null;
var sseErrCount = 0;
// export var hardExit = 'https://' + window.location.host + '/ordertabletloginpage';
// export const hardExit = 'https://pages-eu1.qsignal.eu:1443/exit/nine.html';

// export var hardExit = 'https://google.com/';

export function initSSE(ssePath, openCallback, closedCallback, eDispatcher, uid) {
    // if (isSseConnecting) {
    //     return;
    // }
    // isSseConnecting = true;
    if (eStreamOpen) {
        openCallback(true);
        return;
    }
    retryUid=uid;
    retrySsePath = ssePath;
    // retryRestId = restId;
    retryOpenCallback = openCallback;
    retryClosedCallback = closedCallback;
    retryEdispatcher = eDispatcher;

    try{
        eSource = new EventSource(ssePath, {withCredentials: false});

        eSource.addEventListener('open', (e) => {
            eStreamOpen = true;
            // isSseConnecting = false;
            sseErrCount = 0;
            openCallback(false);
        }, false);

        // EventSource lost connection or timed out
        eSource.addEventListener('error', (e) => {
            try {
                eStreamOpen = false;
                sseErrCount += 1;
                //if (e.readyState == EventSource.CLOSED) {
                console.log('**** ERROR count ' + sseErrCount, e);
                // console.log('**** ERROR: ' + e);
            } catch (e) {
                //suck
            } finally {
                //Reinit
                closeSSE();
                // setTimeout(() => {
                //     reinitSse();
                // }, 5000);
                if (sseErrCount > 300) {
                    // window.location.replace(hardExit);
                }
            }
            //}
        }, false);

        eSource.addEventListener('heartbeat', (e) => {
            console.log('.')
        }, false);

        eSource.addEventListener('shop', (e) => {
            //Security: verify e.origin in your message handler matches your app's origin:
            if (e.origin !== 'https://' + window.location.host) {//'http://example.com'
                // alert('Origin was not ' + host);
                return;
            }
            let data = JSON.parse(e.data);
            eDispatcher(data);
        }, false);

        //P2P messages for one uid
        console.log('P2P uid = '+uid);
        eSource.addEventListener('user' + uid, (e) => {
            if (e.origin !== 'https://' + window.location.host) {//'http://example.com'
                // alert('Origin was not ' + host);
                return;
            }
            var data = JSON.parse(e.data);
            console.log('P2P message:', data);
            eDispatcher(data);
        }, false);
    }catch (e) {
        console.error('browser does not support eventsource');
    }

}//eof initSSE()

// initSSE();

export function reinitSse() {
    if (!eStreamOpen && retrySsePath) {
        initSSE(retrySsePath, retryOpenCallback, retryClosedCallback, retryEdispatcher, retryUid);
    }
}

export function closeSSE(force) {
    if (retryClosedCallback) {
        retryClosedCallback();
    }
    // // if (!eStreamOpen) {
    // //     return;
    // // }
    // // setTimeout(() => {
    // //     reinitSse();
    // // }, 8000);
    if(force){
        try {
            eStreamOpen = false;
            eSource.close();
        } catch (e) {
            //suck
        }
    }
}

//init visibility variables
// let visible = true;
// let hidden, visibilityChange;
let visibilityChange;
if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
    // hidden = "hidden";
    visibilityChange = "visibilitychange";
} else if (typeof document.mozHidden !== "undefined") {
    // hidden = "mozHidden";
    visibilityChange = "mozvisibilitychange";
} else if (typeof document.msHidden !== "undefined") {
    // hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
    // hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
}

const visibilityController = () => {
    if (document.visibilityState === 'visible') {
        reinitSse();
        ebus.$emit('pageVisible');
    } else {
        closeSSE();
        ebus.$emit('pageHidden');
    }
    // if (document[hidden]) {
    //     visible = false;
    //     //don't exit the app when not visible
    //     closeSSE();
    //     ebus.$emit('pageHidden');
    // } else {
    //     visible = true;
    //     reinitSse();
    //     ebus.$emit('pageVisible');
    // }
};

// export function isVisible() {
//     return visible;
// }

// console.log('??? add visibilityController');
document.addEventListener(visibilityChange, visibilityController);

window.addEventListener('pageshow', (event) => {
    // event.type
    // event.persisted
    ebus.$emit('pageshow');
}, false);

window.addEventListener('pageshide', (event) => {
    ebus.$emit('pageshide');
}, false);

window.addEventListener('freeze', (event) => {
    ebus.$emit('freeze');
}, false);

// window.addEventListener("offline", function () {
//   //testConnection(true);
//   console.log('window offline!');
// }, true);
